import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)`
  border-radius: 8px;
  font-weight: bold;
  padding: 10px 20px;
  background-color: #f58220;
  color: #ffffff;
  text-transform: capitalize;
  min-width: 250px;
  &:hover {
    background-color: #e5731e;
  }
`;
